import { Link } from 'react-router'

export function NotFoundScreen() {
	return (
		<div className="empty">
			<h1>Page not found</h1>
			<Link to="/">Back to charts</Link>
		</div>
	)
}
